import { loginGuard } from '../login_guard'

export const administration = {
  path: '/administration',
  beforeEnter: loginGuard,
  component: () => import('layouts/RootLayout.vue'),
  children: [
    {
      path: '',
      name: 'administration',
      component: () => import('pages/AdministrationHomePage.vue')
    },
    {
      path: 'taxonomies/',
      props: true,
      name: 'administration-taxonomy-list',
      component: () => import('pages/taxonomies/ListTaxonomyPage.vue')
    },
    {
      path: 'taxonomies/:code',
      props: true,
      name: 'administration-taxonomy-edit',
      component: () => import('pages/taxonomies/EditTaxonomyPage.vue')
    },
    {
      path: 'reports/',
      props: true,
      name: 'administration-reports',
      component: () => import('pages/reports/ReportsPage.vue')
    }
  ]
}
